import { useSettings } from '@/hooks/useSettings';
import useAnalytics from '@/lib/analytics/useAnalytics';
import { Award } from 'lucide-react';
import { usePathname, useRouter } from 'next/navigation';
import Feedback from '../Feedback';
import HelpMenu from '../Menus/HelpMenu';
import SidebarItem from './SidebarItem';

const SidebarSupport = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { track } = useAnalytics();
  const { setReturnPage } = useSettings();

  const handleInviteClick = () => {
    track('Invite and Earn Clicked', {
      source: 'Sidebar',
    });
    setReturnPage(pathname ?? '/new');
    router.push('/settings/referrals');
  };

  return (
    <div className="flex flex-col">
      <SidebarItem icon={Award} onClick={handleInviteClick}>
        Invite and earn
      </SidebarItem>

      <Feedback />
      <HelpMenu />
    </div>
  );
};

export default SidebarSupport;
